export default {
  // Breadcrumb
  projectList: 'Project List',
  deviceList: 'Device List',
  firmwareManagement: 'Firmware Management',

  // Buttons
  uploadButton: 'Click to Upload',
  cancelButton: 'Cancel',
  confirmButton: 'Confirm',
  importFirmwareFile: 'Import Firmware File',

  // Form labels
  availableLabel: 'Available',
  deviceNameLabel: 'Device Name',
  releaseNoteLabel: 'Release Note',
  fileLabel: 'File',
  deviceNamePlaceholder: 'Multiple selection allowed',
  releaseNotePlaceholder: 'Please enter firmware release note',
  versionPlaceholder: 'Please enter version number',

  // Table column headers
  modelColumn: 'Model',
  fileNameColumn: 'File Name',
  firmwareVersionColumn: 'Firmware Version',
  fileSizeColumn: 'File Size',
  creatorColumn: 'Creator',
  releaseDateColumn: 'Release Date',
  releaseNoteColumn: 'Release Note',
  statusColumn: 'Status',

  // Validation messages
  releaseNoteRequired: 'Please enter release note.',
  deviceNameRequired: 'Please select the device model for this firmware.',
  fileRequired: 'Please select at least one file.',
  formatError: 'Format error. Please select zip file.',

  // Upload messages
  uploading: 'Uploading',
  uploadCompleted: 'Uploaded',
  uploadFailed: 'Upload Failed',
  uploadingDescription: 'Uploading...',
  uploadCompletedDescription: 'File upload completed',
  uploadFailedDescription: 'Check and retry.',

  // Filter options
  all: 'All',
}
